export default "__VITE_ASSET__BtQbj52b__"